export function formatDateTime(value) {
    if (!value) return 'Sin fecha de finalización';
    return new Date(value).toLocaleString('es-MX');
}

export function isEnded(value) {
    if (!value) return false;
    return new Date(value).getTime() <= Date.now();
}
